import type { RouteLocationNormalized } from 'vue-router'
import { useAccountStore } from '@/stores/account'
import { session } from '@/helpers/auth'

export const setExecutiveData = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized
): Promise<boolean> => {
  if (!session()) return true

  const storeAccount = useAccountStore()

  if (storeAccount.executiveDataFetched) return true

  await storeAccount.setExecutiveData()
  return true
}